function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,0)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 948 501 L 499 104 L 51 501 L 0 443 L 498 0 L 1000 442 M 277 134 L 147 249 L 147 52 L 277 52 M 846 466 L 511 179 C 508 176 504 175 500 175 C 496 175 492 176 488 179 L 153 466 C 149 469 147 474 147 479 L 147 931 C 147 940 155 948 164 948 L 389 948 L 389 750 C 389 742 396 735 405 735 L 594 735 C 603 735 610 742 610 750 L 610 948 L 835 948 C 844 948 852 940 852 931 L 852 479 C 852 474 850 469 846 466 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.ddc1804c73f2cffc0e944725cd8c6717.svg";
export { ForwardRef as ReactComponent };